<script lang="ts">
    export let href: string;
    export let primary = false;
    export let dark = false;
    export let paddedType = "ultra";
    export let ariaLabel = "";
</script>

<a
    {href}
    on:click
    class="no-underline font-extrabold text-lg cursor-pointer rounded-sm text-center outline-none inline-block pl-4 pr-4"
    class:primary
    class:secondary={!primary}
    class:dark
    class:p-3={!paddedType || paddedType === "ultra"}
    class:p-1={paddedType === "normal"}
    aria-label={ariaLabel}
>
    <span>
        <slot />
    </span>
</a>

<style>
    a {
        touch-action: manipulation;
    }
    .primary {
        color: rgba(255, 255, 255);
        background: none repeat scroll 0 0 #000000;
        border: 1px solid #00000;
        border-radius: 8px;
        font-weight: normal;
    }
    .primary:hover {
        color: rgba(255, 255, 255);

        background: none repeat scroll 0 0 #393939;
    }
    .primary:disabled {
        color: #eee;
        background: none repeat scroll 0 0 #bbc0b7;
        border: 1px solid #292929;
    }

    .secondary {
        color: #fafafa;
        background-color: transparent;
        border: 1px solid #fafafa;
    }
    .secondary:hover {
        border: 1px solid #353535;
    }
    .secondary.dark {
        color: #333;
        background-color: transparent;
        border: 1px solid #333;
    }
    .secondary.dark:hover {
        border: 1px solid #888;
        color: #888;
    }
</style>
